import { IPlanningItemEntity } from '@phrospr/lib-models';

export let planningDetail: IPlanningItemEntity;

export let PlanningParameters: { listDate: Date } = {
    listDate: null,
};

export function cachePlanningDetail(planningDetailToCache: IPlanningItemEntity) {
    planningDetail = planningDetailToCache;
}

export function getPlanningParameterListDate() {
    if (!PlanningParameters.listDate) {
        return null;
    }
    const listDate = PlanningParameters.listDate;
    delete PlanningParameters.listDate;
    return listDate;
}
